<template>
  <div class="main">
    <div class="topNav">
      <div class="navContent">
        <div class="navLeft">
          <ul>
            <li>
              <a class="l"><img src="@/assets/img/logoWhite.png" width="120" style="margin-top:18px" /></a>
            </li>
          </ul>
        </div>
        <div class="navRight">
          <ul>
            <li><i class="fa fa-telPhoneTop marR5"></i>+86 13798479219</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="leftNav">
      <div class="navCont">
        <div class="title font12">
          <h3><i class="fa fa-steps1 marR5 "></i>My historical orders</h3>
        </div>
        <div class="navBtn clear">
          <a :class="IsTodayShow ? 'btn01 btnBlue' : 'btn01'" @click="TodaySelect()">current</a>
          <a :class="IsMonth ? 'btn02 btnBlue' : 'btn02'" style="padding: 7px 5px;" @click="MonthSelect()">Last month</a>
          <a :class="IsMore  ? 'btn03 btnBlue' : 'btn03'" @click="MoreSelect()">More</a>
        </div>
        <div style="clear:both"></div>
        <div class="ovShow">
          <ul v-for="item in OrderInfo">
            <li :class="item.order_id == SelectID ? 'bagBlue':''" @click="GetOrderId(item.order_id)">{{item.order_id}}</li>
          </ul>
        </div>
      </div>
    </div>
    <router-view :IsWhat='IsWhat'></router-view>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import { getCookie } from '@/ask/cookiejs';
import bus from '@/ask/eventBus'
import { post, fetch } from '@/ask/axios'
export default {
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      IsTodayShow: true,
      IsMonth: false,
      IsMore: false,
      content: "", // 分享的邮箱
      StartWaybillNO: '', //一开始的分享订单号
      WaybillNO: '', // 查看的编号
      SelectID: '', // 选择查看的编号
      OrderStartTime: '',
      OrderEndTime: '',
      OrderInfo: [],
      IsWhat: ''
    }
  },
  created() {
    this.content = this.$route.query.content
    this.WaybillNO = this.$route.query.WaybillNO
    this.StartWaybillNO = this.$route.query.WaybillNO
    if (this.WaybillNO.substring(0, 2) == 'WA') {
      this.IsWhat = 'IsAir'
    } else {
      this.IsWhat = 'IsExp'
    }
    this.TodaySelect()
  },
  methods: {
    TodaySelect() {
      this.IsMonth = false
      this.IsMore = false
      this.IsTodayShow = true
      this.OrderInfo = [{ order_id: this.StartWaybillNO }]
    },
    MonthSelect() {
      let myDate = new Date();
      myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate()
      myDate.setMonth(myDate.getMonth() - 1);
      this.OrderStartTime = myDate.Format('yyyy-MM-dd 00:00:00')
      this.OrderEndTime = new Date().Format('yyyy-MM-dd 23:59:59.999');
      this.IsTodayShow = false
      this.IsMore = false
      this.IsMonth = true
      this.SelectOrder()
    },
    MoreSelect() {
      this.IsMore = true
      this.IsMonth = false
      this.IsTodayShow = false
      // 三个月前
      let myDate = new Date();
      myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate()
      myDate.setMonth(myDate.getMonth() - 3);
      this.OrderStartTime = myDate.Format('yyyy-MM-dd 00:00:00')

      this.OrderEndTime = new Date().Format('yyyy-MM-dd 23:59:59.999');
      this.SelectOrder()
    },
    SelectOrder() {
      let that = this;
      that.api.param = {
        userNames: that.$route.query.content,
        readName: that.$route.query.content,
        remark: '22222',
        startDate: that.OrderStartTime,
        endDate: that.OrderEndTime
      }
      //console.log(that.api.param,that.OrderStartTime)
      that.api.url = that.$api03 + "/api/TradeCustomer/OuterOrderOnlineInfo/GetWorkList";
      fetch(that.api.url, that.api.param).then(function (res) {
        that.OrderInfo = res.Results
      })
    },
    GetOrderId(id) {
      this.SelectID = id
      if (id.substring(0, 2) == 'WA') {
        this.$router.push({ name: 'receiptAirDetails', query: { content: this.content, WaybillNO: id } })
      } else {
        this.$router.push({ name: 'receiptExpDetails', query: { content: this.content, WaybillNO: id } })
      }
    }
  }
}

</script>

<style type="text/css" rel="stylesheet" scoped="scoped">
* {
  box-sizing: border-box;
}
.leftNav {
  width: 100%;
  height: 100%;
  background: #fff;
  width: 190px;
  position: fixed;
  border-right: 1px solid #ddd;
  padding-top: 70px;
}
.navCont {
  margin: 5px;
}
.navCont .title {
  background: #12306a;
  color: #fff;
  height: 35px;
  line-height: 35px;
  border-radius: 5px;
  text-align: center;
}
.navCont .navBtn {
  margin-top: 5px;
}
.navCont .navBtn a {
  display: inline-block;
  font-size: 13px;
  float: left;
  cursor: pointer;
  padding: 7px 4px;
}
.navCont .navBtn a.btn01 {
  border: 1px solid #ddd;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.navCont .navBtn a.btn02 {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.navCont .navBtn a.btn03 {
  border: 1px solid #ddd;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.navCont .navBtn a.btnBlue {
  background: #0c5ee4 !important;
  color: #fff;
}
.navCont ul {
  margin-top: 10px;
  border-bottom: 0px !important;
  border: 1px solid #eee;
}
.navCont ul li {
  font-size: 13px;
  line-height: 30px;
  border-bottom: 1px solid #eee;
  text-align: center;
  cursor: pointer;
}
.navCont ul li.on {
  background: #f0f0f0;
}
.navCont ul li:hover {
  background: #bababa;
  color: white;
}
.navCont .bagBlue {
  background: #bababa;
  color: white;
}

.ovShow {
  max-height: 650px;
  overflow: auto;
  margin-top: 5px;
}

.topNav {
  height: 60px;
  background: #12306a;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  position: fixed;
  z-index: 99999;
  width: 100%;
}
.navContent {
  width: 95%;
  height: 60px;
  margin: auto 2%;
}
.navContent .navLeft {
  float: left;
}
.navContent .navLeft ul li {
  line-height: 70px;
  margin: 0 10px;
  float: left;
  display: inline-block;
}
.navContent .navLeft ul li a {
  color: #666;
  font-size: 14px;
  font-family: "Microsoft YaHei";
}
.navContent .navLeft ul li a:hover {
  color: #0c5ee4;
}
.navContent .navLeft ul li a {
  color: #666;
  font-size: 14px;
  font-family: "Microsoft YaHei";
}
.navContent .navLeft ul li.lineGary {
  color: #bababa;
  margin: 0 0px !important;
}

.navContent .navRight {
  float: right;
}
.navContent .navRight ul li {
  float: left;
  font-size: 14px;
  color: #fff;
  line-height: 60px;
}
.navContent .navRight ul li img {
  vertical-align: middle;
  float: left;
}
</style>




// WEBPACK FOOTER //
// src/components/receiptPage/receipt.vue